import { z } from 'zod';

export const cognitoTokenPayloadSchema = z.object({
    'cognito:groups': z.array(z.string()).optional(),
    email: z.email(),
    picture: z.string().optional(),
    'custom:scopes': z.string().optional(),
    'custom:instance_ids': z.string().optional(),
    'custom:customer_ids': z.string().optional(),
    'custom:location_ids': z.string().optional(),
    'custom:practice_ids': z.string().optional(),
    'custom:map_practitioner_id': z.string().optional(),
});

export type CognitoTokenPayload = z.infer<typeof cognitoTokenPayloadSchema>;
